module.exports = __webpack_public_path__ + "static/media/footerBG.83acf969.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/footerBG.png
// module id = 682
// module chunks = 11